// check and set up cookie consent
(function () {
  var cookieProp = 'accept_cookies';
  var cookieWidgetAppearDelay = 5000;

  if (window.localStorage.getItem(cookieProp) === '1') {
    onCookiesAccepted()
    return;
  }

  // Pricing pages on phones: the box covers the plan cards, so skip it there.
  // (Consent state is untouched, so it shows again on any other page.)
  var pathname = window.location.pathname || '';
  var isPricingPage = pathname.indexOf('/pricing') === 0;
  var isPhoneView = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  if (isPricingPage && isPhoneView) {
    return;
  }

  var cookiebox = document.createElement('div');
  cookiebox.className = 'cookie-box';
  cookiebox.setAttribute('role', 'dialog');
  cookiebox.setAttribute('aria-modal', 'false');
  cookiebox.setAttribute('aria-live', 'polite');
  cookiebox.setAttribute('aria-labelledby', 'cookie-consent-title');
  cookiebox.setAttribute('aria-describedby', 'cookie-consent-desc cookie-consent-more');
  cookiebox.innerHTML =
    '<div class="message-wrap"><h2 id="cookie-consent-title">Cookies on Livepush</h2><p id="cookie-consent-desc">We use cookies and browser storage to keep you signed in, remember preferences, and understand site performance.</p><p id="cookie-consent-more">Read our <a href="/privacypolicy/index.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> for details.</p></div>';

  var actionswrap = document.createElement('div');
  actionswrap.className = 'actions-wrap';

  var consentbtn = document.createElement('button');
  consentbtn.type = 'button';
  consentbtn.textContent = 'Accept cookies';
  consentbtn.onclick = onCookiesAccepted;
  actionswrap.appendChild(consentbtn);
  cookiebox.appendChild(actionswrap);
  document.body.appendChild(cookiebox);

  function onCookiesAccepted() {
    window.localStorage.setItem(cookieProp, '1');

    if (window.gtag) {
      // ad_storage must be granted or gtag.js never writes the _gcl_aw cookie,
      // which is what carries the Google Ads click id into the signup request.
      // ad_personalization is deliberately left denied — that one is for
      // remarketing audiences, which conversion tracking does not need.
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'analytics_storage': 'granted'
      });
    }
    hideCookieBox();
  }

  function showCookieBox() {
    if (!cookiebox) return;

    cookiebox.classList.add('visible');
  }

  function hideCookieBox() {
    if (!cookiebox) return;

    cookiebox.classList.remove('visible');
    setTimeout(() => {
      document.body.removeChild(cookiebox);
    }, 1000);
  }

  setTimeout(showCookieBox, cookieWidgetAppearDelay);
})();
